export default __webpack_public_path__ + "static/media/istriwala.9701ff82.png";